// Miniaturní trend do KPI karty. Vlastní SVG místo recharts — pro pár desítek
// pixelů křivky je celý chart runtime zbytečná zátěž (4 instance na stránku).
// Měsíce bez dat (null) se přeskakují, nekreslí se jako nula.
//
// `fluid` = křivka se roztáhne na šířku rodiče (dlaždice v pravém panelu).
// Kreslí se pořád do souřadnic `width`, jen se nechá škálovat viewBoxem;
// `vector-effect` drží tloušťku čáry, aby se roztažením nerozmazala.
export default function Sparkline({ body, color, width = 72, height = 26, fluid = false }) {
    if (!body || body.length < 2) return null;
    const platne = body.map((v, i) => [i, v]).filter(([, v]) => v != null);
    if (platne.length < 2) return null;

    const hodnoty = platne.map(([, v]) => v);
    const min = Math.min(...hodnoty);
    const max = Math.max(...hodnoty);
    const rozsah = max - min || 1;
    const krok = body.length > 1 ? width / (body.length - 1) : width;
    const pad = 3;

    const body2d = platne.map(([i, v]) => {
        const x = i * krok;
        const y = pad + (1 - (v - min) / rozsah) * (height - pad * 2);
        return `${x.toFixed(1)},${y.toFixed(1)}`;
    });

    return (
        <svg width={fluid ? '100%' : width} height={height} viewBox={`0 0 ${width} ${height}`}
            preserveAspectRatio={fluid ? 'none' : undefined}
            style={{ opacity: 0.8, display: 'block' }} aria-hidden="true">
            <polyline points={body2d.join(' ')} fill="none" stroke={color} strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
        </svg>
    );
}
